import { Box, Button, FormControl, FormHelperText, Grid, Paper, TextField, Typography } from "@mui/material";
import { useSnackbar } from "notistack";
import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { useSelector } from "react-redux";
import { RootState } from "../../../app/store";
import configUrls from "../../../config/configUrls";
import errorFormat from "../../../utils/errorFormat";

import { ISprocessoAnotacao, ProcessoAnotacao } from "../../../types/processo/ProcessoAnotacao";
import { ProcessoAnotacaoDTO } from "../../../types/processo/ProcessoAnotacaoDTO";
import { useAddAnotacaoMutation, useGetProcessoAnotacaoQuery } from "../processoApiSlice";


export const ProcessoAtualizarAnotacaoCreate = () => {

    const [processoAnotacao, SetProcessoAnotacao] = useState<ProcessoAnotacao>(ISprocessoAnotacao);
    const { enqueueSnackbar, closeSnackbar } = useSnackbar()
    const [createAnotacao, status] = useAddAnotacaoMutation();
    const navigate = useNavigate();

    // Hook para seleção do processo
    const { processoSelecionado } = useSelector((state: RootState) => state.processoSelecionado);
    useEffect(() => {
        if (!processoSelecionado) {
            alert("Nenhum processo foi previamente selecionado");
            navigate(configUrls.PROCESSO_LIST_RT); // Usando useNavigate para navegação
        }
    }, [processoSelecionado, navigate]);


    //verificar se for edicao ele pega o id e faz a consulta 
    const id = useParams().id || "";
    const { data, isFetching, error } = useGetProcessoAnotacaoQuery(id);
    useEffect(() => {
        if (data) {
            SetProcessoAnotacao(data);
        }
    }, [data, error, isFetching])





    const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        const { name, value } = e.target;
        const cursorPosition = e.target.selectionStart;

        SetProcessoAnotacao((prev) => ({
            ...prev,
            [name]: value.toUpperCase(),
        }));

        // Aguarde até que o DOM seja atualizado
        setTimeout(() => {
            const input = e.target;
            input.setSelectionRange(cursorPosition, cursorPosition);
        }, 0);
    };

    async function handleSubmit(e: React.FormEvent<HTMLFormElement>) {
        e.preventDefault();
        const parms: ProcessoAnotacaoDTO = {
            id: processoAnotacao.id,
            descricao: processoAnotacao.descricao,
            processoID: processoSelecionado ? processoSelecionado.id : "",
        }
        await createAnotacao(parms);
    }

    useEffect(() => {

    

        if (status.isError) {
            enqueueSnackbar("Registro não incluído!", { variant: "error" })
            const erroReturn: string = errorFormat(status);
            enqueueSnackbar(erroReturn, { variant: "error" })
        }

        if (status.isSuccess) {
            enqueueSnackbar("Registro incluído!", { variant: "success" })
            navigate(-1);
            // setGrupo(ISgrupo);          

        }
    }, [status]);








    return (



        <>


            <Paper>

                <Typography variant="h6" component="h1" sx={{ padding: 2 }}>
                    Anotação (ões) do processo: {processoSelecionado?.numeroProcesso}

                </Typography>
                <Box mt={2} p={2}>

                    <form onSubmit={handleSubmit} method='POST'>

                        <Grid container spacing={3}>
                            <Grid item xs={12}>
                                <FormControl fullWidth>
                                    <TextField
                                        required
                                        label="Descricão:"
                                        name="descricao"
                                        onChange={handleChange}
                                        size="small"
                                        inputProps={{ maxLength: 255 }}
                                        value={processoAnotacao.descricao}
                                        multiline  // Adiciona o suporte a múltiplas linhas
                                        rows={4} />


                                    <FormHelperText>
                                        {processoAnotacao.descricao?.length}/255 caracteres
                                    </FormHelperText>
                                </FormControl>
                            </Grid>


                            <Grid item xs={12}>
                                <Box display="flex" gap={2}>

                                    <Button
                                        type="submit"
                                        variant="contained"
                                        color="secondary"
                                    >
                                        Gravar
                                    </Button>

                                    <Button
                                        variant="contained"
                                        onClick={() => navigate(-1)}
                                    >
                                        Voltar
                                    </Button>
                                </Box>
                            </Grid>
                        </Grid>

                    </form>



                </Box>




            </Paper>










        </>







    );










};

/*
 <GrupoTurmaForm
                    grupoTurma={grupoTurmaState}
                    isdisabled={status.isLoading}
                    isLoading={status.isLoading}
                    handleSubmit={handleSubmit}
                    handleChange={handleChange}
                />
*/